import { Vendedor } from "app/types/Vendedor"
import clsx from "clsx"
import { FormikErrors, useFormik } from "formik"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import { InputData } from "../inputs/InputData"
import { IFilial } from "app/types/IFilial"
import R from "ramda"
import { ComissaoPorClassificacaoResultado } from "app/types/Comissao-por-classificacao/ComissaoPorClassificacao"

const estilosBotoes = require("../../estilos/botoes.module.scss").default;
const estilosInputs = require('../../estilos/inputs.module.scss').default
const estilosTabelas = require('../../estilos/tabelas.module.scss').default

export type ComissaoPorClassificacaoProps = {
    Processando?: boolean
    VendedorLogado: Partial<Vendedor>
    ListaFiliais: Partial<IFilial>[]
    ListaVendedores: Partial<Vendedor>[]
    Resultado: ComissaoPorClassificacaoResultado[]
    onPesquisar: (codigoVendedor: string, codigoFilial: string, dataInicial: Date, dataFinal: Date) => void

}
  

export const ComissaoPorClassificacao = (props: ComissaoPorClassificacaoProps) => { // 482087

    const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
    const [initialDates] = useState({
        DataInicial: globalMU.converterObjetoDateParaDataFormatoPT(new Date()),
        DataFinal: globalMU.converterObjetoDateParaDataFormatoPT(new Date())
    })



    const formik = useFormik({
        initialValues: {
            CodigoFilial: props.VendedorLogado?.CodigoFilial ?? "",
            CodigoVendedor: props.VendedorLogado?.CodigoVendedor ?? "",
            DataInicial: initialDates.DataInicial,
            DataFinal: initialDates.DataFinal,
        },
        onSubmit: async (values) => {

            const erros = await formik.validateForm(values)
            if (Object.keys(erros).length == 0) {
                props.onPesquisar(formik.values.CodigoVendedor, 
                                formik.values.CodigoFilial, 
                                globalMU.converterDataFormatoPTParaDate(formik.values.DataInicial), 
                                globalMU.converterDataFormatoPTParaDate(formik.values.DataFinal),
                            )
            }
        },
        enableReinitialize: true,
        validate: (values) => {
            const errors: FormikErrors<any> = {}

            // Validação das datas
            if (!values.DataInicial) {
                errors.DataInicial = "A data inicial é obrigatória."
            }
            if (!values.DataFinal) {
                errors.DataFinal = "A data final é obrigatória."
            }

            // Comparação das datas (apenas se ambas forem válidas)
            if (values.DataInicial && values.DataFinal) {
                const dataInicial = new Date(values.DataInicial)
                const dataFinal = new Date(values.DataFinal)
                if (dataInicial.getTime() > dataFinal.getTime()) {
                    errors.DataInicial = "A data inicial não pode ser maior que a data final."
                }
            }

            return errors
        },
    })

    useEffect(() => {
        if (props.VendedorLogado != null && props.ListaVendedores != null && props.ListaVendedores.length > 0) {
            formik.setFieldValue("CodigoVendedor", props.VendedorLogado?.Codigo ?? "")
        }
    }, [props.ListaVendedores, props.VendedorLogado])

    return (
        <>
            <form
                id="ComissaoPorClassificacao_FormularioFiltroPesquisa"
                onSubmit={(e) => {
                    e.preventDefault()
                    formik.validateForm().then((erros) => {
                        if (Object.keys(erros).length == 0) {
                            setFormularioValidado(true)
                        }
                        else{
                             const mensagensErro = Object.values(erros).join("<br/>")
                             globalMU.showErrorMessage(mensagensErro)
                        }
                    })
                    formik.handleSubmit()
                }}
            >
                <div className="_mt-4 _mb-8">

                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Filial</label>
                        <select
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            disabled={props.Processando || props.ListaFiliais?.length <= 1}
                            id="ComissaoPorClassificacao_CampoFiltro_Filial"
                            multiple={false} 
                            value={formik.values.CodigoFilial ?? ''}
                            onChange={(e) => formik.setFieldValue("CodigoFilial", e.target.value)}
                        >
                            <option 
                              value={""} 
                              id="ComissaoPorClassificacao_CampoFiltro_Filial_Vazio"
                            >
                              Selecione
                            </option>
                            {props.ListaFiliais?.map((value) => (
                                <option 
                                  key={value.Codigo} 
                                  value={value.Codigo}
                                  id={ `ComissaoPorClassificacao_CampoFiltro_Filial_${value.Codigo}`}
                                >
                                    {value.Descricao}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Vendedor</label>
                        <select
                            disabled={props.ListaVendedores?.length <= 1 || props.Processando}
                            id="ComissaoPorClassificacao_CampoFiltro_Vendedor"
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            name="CodigoVendedor"
                            value={formik.values.CodigoVendedor ?? ''}
                            onChange={(e) => formik.setFieldValue("CodigoVendedor", e.target.value)}
                        >
                            <option 
                              value={""} 
                              id={ `ComissaoPorClassificacao_CampoFiltro_Vendedor_Vazio`}
                            >
                              Selecione
                            </option>
                            {props.ListaVendedores?.map((value) => (
                                <option key={value.CodigoVendedor} value={value.CodigoVendedor}
                                id={ `ComissaoPorClassificacao_CampoFiltro_Vendedor_${value.CodigoVendedor}`}
                                >
                                    {value.Nome}
                                </option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data Inicial</label>
                        <InputData
                            id="ComissaoPorClassificacao_CampoFiltro_DataInicial"
                            key="ComissaoPorClassificacao_CampoFiltro_DataInicial"
                            disabled={props.Processando}
                            className={`_w-[200px] ${estilosInputs.inputPadrao} ${formularioValidado && formik.errors.DataInicial != undefined && estilosInputs.inputComErro}`}
                            data={formik.values.DataInicial}
                            onChange={(e) => { 
                               
                                formik.setFieldValue("DataInicial", globalMU.converterDataFormatoENParaPT(e))
                            }}
                            
                            selecionaValorOnFocus
                        />
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data Final</label>
                        <InputData
                            id="ComissaoPorClassificacao_CampoFiltro_DataFinal"
                            key="ComissaoPorClassificacao_CampoFiltro_DataFinal"
                            disabled={props.Processando}
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            data={formik.values.DataFinal}
                            onChange={(e) => {
                                formik.setFieldValue("DataFinal", globalMU.converterDataFormatoENParaPT(e))}
                            }
                            selecionaValorOnFocus
                        />
                    </div>
                </div>


                <div>
                    <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                        type="submit"
                        id="ComissaoPorClassificacao_BotaoProcurar"
                        disabled={props.Processando}
                    >Procurar</button>
                </div>
            </form>

            {props.Resultado && props.Resultado.length > 0 && (
                <div className="_mb-4" style={{ overflow: "auto"}}>
                    <table 
                        className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}
                        id="ComissaoPorClassificacao_TabelaResultado"
                    >
                        <thead>
                            <tr
                                id="ComissaoPorClassificacao_TabelaResultado_Cabecalho"
                            >
                                <th 
                                    id="ComissaoPorClassificacao_TabelaResultado_Cabecalho_Vendedor"
                                    className={estilosTabelas.cabecalhoTexto}
                                >
                                    Vendedor</th>
                                <th 
                                   id="ComissaoPorClassificacao_TabelaResultado_Cabecalho_TotalVenda" 
                                   className={estilosTabelas.cabecalhoNumerico}
                                >
                                    Total de Vendas</th>
                                <th 
                                   id="ComissaoPorClassificacao_TabelaResultado_Cabecalho_TotalComissao" 
                                   className={estilosTabelas.cabecalhoNumerico}
                                >
                                    Comissão</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.Resultado.map((item, index) => (
                                <tr 
                                    key={index}
                                    id={`ComissaoPorClassificacao_Resultado_Linha_${index}`}
                                    className={estilosTabelas.linha}
                                >

                                    <td
                                        key={ `ComissaoPorClassificacao_Resultado_${index}_Vendedor`}
                                        id={ `ComissaoPorClassificacao_Resultado_${index}_Vendedor`}
                                        className={estilosTabelas.dadoTexto}
                                    >
                                        {item.Vendedor}
                                        </td>
                                    <td
                                        key={ `ComissaoPorClassificacao_Resultado_${index}_TotalVenda`}
                                        id={ `ComissaoPorClassificacao_Resultado_${index}_TotalVenda`}
                                        className={estilosTabelas.dadoNumerico}
                                    >
                                        { globalMU.formatMoney(item.TotalVenda)}
                                    </td>
                                    <td
                                        key={ `ComissaoPorClassificacao_Resultado_${index}_TotalComissao`}
                                        id={ `ComissaoPorClassificacao_Resultado_${index}_TotalComissao`}
                                        className={estilosTabelas.dadoNumerico}
                                    >
                                        { globalMU.formatMoney(item.TotalComissao)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) 
            }
                        

            {<section style={{ marginBottom: "100px" }} />}
        
        </>
    )
    
}